import { render, staticRenderFns } from "./MyConfirm.vue?vue&type=template&id=e6d71e12&scoped=true"
import script from "./MyConfirm.vue?vue&type=script&lang=js"
export * from "./MyConfirm.vue?vue&type=script&lang=js"
import style0 from "./MyConfirm.vue?vue&type=style&index=0&id=e6d71e12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d71e12",
  null
  
)

export default component.exports